import { createApiEffect } from '@/features/api/common/create-api-effect'
import { ExamAssignment } from '@/features/api/assignment/types/exam-assignments-types'

export const getExamAssignmentFx = createApiEffect<number, ExamAssignment>({
  requestMapper: (id) => ({
    method: 'GET',
    url: `/api/assignment-app/exam-assignment/${id}/`,
  }),
})
